import React, { useState, useContext, useEffect } from "react";
import AttachButton from "./AttachButton";
import DocumentContext from "context/DocumentsContext";
import { BsPlusLg } from "react-icons/bs";
import { getDocuments } from "utils/getDocuments";
import Spinner from "components/Spinner";
import { AiOutlineMinus } from "react-icons/ai";
import { ConfirmActionModal } from "components/modals/ConfirmActionModal";
import ModalWrapper from "components/modals/ModalWrapper";
import { Portal } from "components/Portal/Portal";
import { FaArrowDown } from "react-icons/fa";
import { FaArrowUp } from "react-icons/fa";
import { MdDone } from "react-icons/md";
import { ImCross } from "react-icons/im";
import { DocActionModal } from "components/modals/DocActionModal";

const Colors = {
  tenders: "purple",
  contracts: "blue",
  "separated-projects": "orange",
  "measuring-blocks": "olive",
};

const FileInput = ({
  modelId,
  entity,
  link,
  isShowDonwload = true,
  title,
  isUpload,
  setIsUpload,
  contractId,
}) => {
  const [doc, setDoc] = useState([]);
  const [files, setFiles] = useState([]);
  const [isOpenList, setIsOpenList] = useState({});
  const [isSuccess, setIsSuccess] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [confirmActionModalOpen, setConfirmActionModalOpen] = useState(false);
  const [docIdForRemove, setDocIdForRemove] = useState(null);
  const color = Colors[entity];
  const { uploadDocument, downloadDocument, removeDocument } =
    useContext(DocumentContext);

  const chooseFile = async (e, fileType) => {
    setFiles([
      ...doc,
      { file: e.target.files[0], fileType: fileType, id: doc.length },
    ]);
  };

  const updateDocuments = async () => {
    if (modelId) await getDocuments(entity, modelId).then((res) => setDoc(res));
  };

  const toggleDocumentsList = async (listTitle) => {
    setIsOpenList({ ...isOpenList, [listTitle]: !isOpenList[listTitle] });
  };

  const handleModal = (id) => {
    setDocIdForRemove(id);
    setConfirmActionModalOpen(true);
  };

  const handleRemove = async (id) => {
    await removeDocument(id);
    setConfirmActionModalOpen(false);
    updateDocuments();
  };

  const cleanUploadedFile = (id) => {
    setFiles(doc.filter((item) => item.id !== id));
  };

  const handleUpload = async (type, file) => {
    setIsUploading(true);
    setIsSuccess(false);
    const formData = new FormData();
    formData.append("file", file);
    await uploadDocument(
      entity,
      modelId,
      type,
      formData,
      setIsUploading,
      setIsSuccess,
      contractId
    );
    setIsSuccess(false);
    setFiles([]);
    await updateDocuments();
  };

  const handleDownload = async (e, name, extention, link, id) => {
    setIsDownloading(true);
    await downloadDocument(e, name, extention, link, id);
    setIsDownloading(false);
    setIsDownloaded(true);
    setTimeout(() => {
      setIsDownloaded(false);
    }, 1000);
  };

  useEffect(() => {
    if (doc.length === 0) updateDocuments();
    setIsUpload(
      doc.find((item) => item.documentTypeId === link) ? true : false
    );
  }, [doc.length, modelId]);

  return (
    <div style={{ marginTop: 5, maxWidth: 300 }}>
      <div className="doc-buttons">
        <label className="modal__input-title" style={{ width: 220 }}>
          {title}
        </label>
        {files.length !== 1 && (
          <AttachButton
            docType={link}
            isOpenList={isOpenList}
            chooseFile={chooseFile}
            color={color}
          />
        )}
        <button
          className={`button button--square button--${color} ${
            isOpenList[link] && `button--${color}--active`
          }`}
          type="button"
          onClick={() => toggleDocumentsList(link)}
        >
          {isOpenList[link] ? (
            <AiOutlineMinus className="icon--medium" />
          ) : (
            <BsPlusLg className="icon--medium" />
          )}
        </button>
      </div>
      {files &&
        files
          .filter((item) => item.fileType === link)
          .map((item) => (
            <li className="modal__doc-item">
              {item.file.name.length > 40
                ? item.file.name.slice(0, 40) + "..."
                : item.file.name}
              <div className="doc-buttons">
                {!isUploading && !isSuccess && (
                  <>
                    <button
                      className={`button button--square button--${color}`}
                      onClick={() => handleUpload(link, item.file)}
                    >
                      <FaArrowUp className="icon--medium" />
                    </button>
                    <button
                      className={`button button--square button--${color}`}
                      onClick={() => cleanUploadedFile(item.id)}
                    >
                      <ImCross className="icon--medium" />
                    </button>
                  </>
                )}
                {isUploading && !isSuccess && (
                  <Spinner className="icon--spinner" />
                )}
                {!isUploading && isSuccess && <MdDone className="icon--done" />}
              </div>
            </li>
          ))}
      <div
        style={{ maxHeight: 80, overflowY: "scroll", scrollbarWidth: "thin" }}
      >
        {doc &&
          doc.length > 0 &&
          doc
            .filter((doc) => doc?.url?.includes("_" + link + "_"))
            .map((doc) => (
              <li key={doc.id} className="modal__doc-item">
                {doc.name.length > 40
                  ? doc.name.slice(0, 20) + "..."
                  : doc.name}
                {doc.extention}
                <div className="doc-buttons">
                  {isDownloading && !isDownloaded && (
                    <Spinner className="icon--spinner" />
                  )}
                  {!isDownloading && isDownloaded && (
                    <MdDone className="icon--done" />
                  )}
                  <button
                    className={`button button--square button--${color}`}
                    onClick={(e) =>
                      handleDownload(e, doc.name, doc.extention, entity, doc.id)
                    }
                  >
                    <FaArrowDown className="icon--medium" />
                  </button>
                  <button
                    className={`button button--square button--${color}`}
                    onClick={() => handleModal(doc.id)}
                  >
                    <ImCross className="icon--medium" />
                  </button>
                </div>
              </li>
            ))}
      </div>
      {!doc && doc.filter((doc) => doc.typeId === link).length <= 0 && (
        <li className="modal__no-doc-message">
          <i>Нет документов</i>
        </li>
      )}
      {confirmActionModalOpen && (
        <Portal>
          <ModalWrapper>
            <DocActionModal
              title="Вы уверены, что хотите удалить документ"
              onYes={() => handleRemove(docIdForRemove)}
              onNo={() => setConfirmActionModalOpen(false)}
              colorThemeClass={`button--${color}`}
            />
          </ModalWrapper>
        </Portal>
      )}
    </div>
  );
};

export default FileInput;
